import * as tslib_1 from "tslib";
import OAuthApi from "@/apis/oauth";
import { Button, FormModel, Input } from "@h3/antd-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import common from '@cloudpivot/common';
let ModifyPwd = class ModifyPwd extends Vue {
    constructor() {
        super(...arguments);
        this.ruleForm = {
            oldPwd: "",
            newPwd: "",
            surePwd: "",
        };
        this.rules = {};
        this.hasDiff = false;
    }
    beforeMount() {
        this.setRules();
    }
    oldPwd(rule, value, callback) {
        if (value === "") {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips1')}`));
        }
        else if (/[\u4e00-\u9fa5\s]/.test(value)) {
            callback("密码中不能包含汉字和空格");
        }
        else {
            callback();
        }
    }
    newPwd(rule, value, callback) {
        if (value === "") {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips2')}`));
        }
        else if (/[\u4e00-\u9fa5\s]/.test(value)) {
            callback("密码中不能包含汉字和空格");
        }
        else if (value.length < 6 || value.length > 14 || !(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[^\u4e00-\u9fa5\s]{6,14}$/.test(value))) {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips3')}`));
        }
        else if (value === this.ruleForm.oldPwd) {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips4')}`));
        }
        else {
            callback();
        }
    }
    newPwdChange() {
        if (this.ruleForm.surePwd && this.ruleForm.newPwd !== this.ruleForm.surePwd) {
            this.hasDiff = true;
        }
        else {
            this.hasDiff = false;
        }
    }
    surePwd(rule, value, callback) {
        if (value === "") {
            callback(new Error(`${this.$t('languages.common.passwordErrorTips5')}`));
        }
        else {
            callback();
        }
    }
    surePwdChange() {
        if (this.ruleForm.surePwd && this.ruleForm.newPwd !== this.ruleForm.surePwd) {
            this.hasDiff = true;
        }
        else {
            this.hasDiff = false;
        }
    }
    /**
     * 自定义验证规则
     */
    setRules() {
        this.rules = {
            oldPwd: [{ validator: this.oldPwd, trigger: "change" }],
            newPwd: [{ validator: this.newPwd, trigger: "change" }],
            surePwd: [{ validator: this.surePwd, trigger: "change" }],
        };
    }
    /**
     * 修改密码
     */
    submitForm() {
        const ruleForm = this.$refs["ruleForm"];
        ruleForm.validate((valid) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (valid) {
                // rsa加密
                const result = yield OAuthApi.getRsaKey();
                const flag = typeof result === 'object' && result.hasOwnProperty('index') && result.hasOwnProperty('key');
                if (!flag) {
                    return;
                }
                const { index, key } = result;
                const oldPassword = common.utils.RsaEncrypt(this.ruleForm.oldPwd, key);
                const newPassword = common.utils.RsaEncrypt(this.ruleForm.newPwd, key);
                // rsa加密结束
                const params = {
                    index,
                    oldPassword,
                    newPassword,
                };
                const res = yield OAuthApi.changePassword(params);
                if (res.errcode) {
                    this.$message.error(res.errmsg);
                    return;
                }
                this.$message.success(`${this.$t("languages.common.changePwdSuccess")}`);
                this.$emit('success');
            }
        }));
    }
    resetForm() {
        const ruleForm = this.$refs["ruleForm"];
        ruleForm.resetFields();
    }
    close() {
        this.resetForm();
        this.$emit("closepop");
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], ModifyPwd.prototype, "isShow", void 0);
ModifyPwd = tslib_1.__decorate([
    Component({
        name: "modify-pwd",
        components: {
            AButton: Button,
            AFormModel: FormModel,
            AFormModelItem: FormModel.Item,
            AInput: Input,
        },
    })
], ModifyPwd);
export default ModifyPwd;
